/* import __COLOCATED_TEMPLATE__ from './reclaim.hbs.js'; */
var _class2, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { getOwner } from '@ember/owner';
import { inject as service } from '@ember/service';
import { HashicorpCloudVagrant20220930VagrantCloudAccountState as VagrantCloudAccountState } from '@clients/cloud-vagrant-box-registry';
const phases = ['link', 'reclaim'];
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "vagrantContext", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "phase", _descriptor3, this);
    // If the accounts have already been linked then there is only one step remaining,
    // so skip the wizard UI and just show the reclaimable registries.
    //
    // Additionally, this flag is intentionally not reactive. If it were reactive we would
    // lose the wizard continuity when we proceed from link to reclaim and refresh the model.
    _defineProperty(this, "useWizard", this.args.linkedStatus !== VagrantCloudAccountState.LINKED);
  }
  get step() {
    return Math.max(0, phases.indexOf(this.phase));
  }
  async proceed() {
    this.phase = phases[this.step + 1] ?? 'link';
    await this.refreshRoute();
  }
  async goto(phase) {
    if (phases.includes(phase)) {
      this.phase = phase;
      await this.refreshRoute();
    }
  }
  async refreshRoute() {
    const route = getOwner(this)?.lookup('route:registries.reclaim');
    await route?.refresh();
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "phase", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'link';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "proceed", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "proceed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "goto", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "goto"), _class2.prototype), _class2);
export { _class as default };